import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Text24Bold } from '../../../components/utils/Text/Text.styles';
import {
  NavLinkText,
  NavigationContainer,
  NavigationItem,
  PageContainer,
  TitleContainer,
} from './OrganizationAnalyticsPage.styles';
import { ORGANIZATION_CHATTER_ANALYTICS, ORGANIZATION_INFLUENCER_ANALYTICS } from '../../../components/App/routes';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../store/slices/user/slice';
import { CRM_ORGANIZATION_MEMBER_ROLE } from '../../../utils/constants';

const OrganizationAnalyticsPage = () => {
  const user = useSelector(selectUser);
  return (
    <PageContainer>
      <TitleContainer>
        <Text24Bold>Analytics</Text24Bold>
        <NavigationContainer>
          <NavigationItem>
            <NavLink to={ORGANIZATION_CHATTER_ANALYTICS}>
              <NavLinkText>Chatters</NavLinkText>
            </NavLink>
          </NavigationItem>
          {[CRM_ORGANIZATION_MEMBER_ROLE.OWNER, CRM_ORGANIZATION_MEMBER_ROLE.ADMINISTRATOR].includes(user.role) && (
            <NavigationItem>
              <NavLink to={ORGANIZATION_INFLUENCER_ANALYTICS}>
                <NavLinkText>Creators</NavLinkText>
              </NavLink>
            </NavigationItem>
          )}
        </NavigationContainer>
      </TitleContainer>
      <Outlet />
    </PageContainer>
  );
};

export default OrganizationAnalyticsPage;
